module.exports = __webpack_public_path__ + "09044e1ac409f066c882981f61cdb353.svg";